module.exports = __webpack_public_path__ + "assets/videos/covid-hits-home-poster-image-desktop.jpg?v=f3ef4805";